/** Label for Time Tracker access-group / project-team dropdowns */
export function timeTrackerAssignableUserLabel(u) {
  if (!u) return '';
  const base =
    u.display_name ||
    [u.first_name, u.last_name].filter(Boolean).join(' ') ||
    u.email ||
    String(u._id ?? '');
  const role = typeof u.role === 'number' ? u.role : parseInt(u.role, 10);
  if (role === 10) return `${base} (Super Admin)`;
  if ([11, 12, 13].includes(role)) return `${base} (MSP staff)`;
  return base;
}
